import colorConstants from 'app/styles/constants/colors';

const RGBA = (rgb, alpha) =>
  colorConstants[rgb].replace('rgb', 'rgba').replace(')', `, ${alpha})`);

export default RGBA;
